import { getLanguageKeyForFilePath } from '../language-registry.js';
import { resolveNavigation } from './navigation/resolve-navigation.js';
import type { NavigationLookups } from './navigation/navigation-lookups.js';
import type { NavigationContext } from './navigation/types.js';
import { resolverForLanguageKey } from './registry.js';
import type { DbTagRow, LanguageDefinitionResolver } from './types.js';

export type { DbTagRow, LanguageDefinitionResolver } from './types.js';
export {
  resolverForFilePath,
  resolverForLanguageKey,
  RESOLVERS_BY_LANGUAGE_KEY,
  SUPPORTED_RESOLUTION_LANGUAGE_KEYS,
} from './registry.js';

function resolveWithLanguage(ctx: NavigationContext): DbTagRow[] {
  const languageResolver = resolverForLanguageKey(ctx.languageKey);
  if (languageResolver) return languageResolver(ctx);
  return resolveNavigation(ctx).definitions;
}

export function resolveDefinitionCandidates(ctx: NavigationContext): DbTagRow[] {
  return resolveWithLanguage(ctx);
}

export function refHasResolvableDefinitions(ctx: NavigationContext): boolean {
  if (ctx.ref.role === 'def') return true;
  if (ctx.ref.nav_target_path) return true;
  return resolveWithLanguage(ctx).length > 0;
}

/** Build a navigation context from indexed query data. */
export function buildNavigationContext(
  refFile: string,
  ref: DbTagRow,
  lookups: NavigationLookups,
  workspaceFiles: ReadonlySet<string>,
): NavigationContext {
  return {
    refFile,
    ref,
    fileDefs: lookups.loadFileDefs(refFile),
    fileImports: lookups.lookupImportsForFile(refFile),
    lookupDefsInFileNamed: lookups.lookupDefsInFileNamed,
    lookupImportsForFile: lookups.lookupImportsForFile,
    workspaceFiles,
    languageKey: getLanguageKeyForFilePath(refFile),
  };
}

export { resolveNavigation, refHasNavigationTargets } from './navigation/resolve-navigation.js';
export { followImportBinding, resolveImportedDefinitions } from './navigation/import-target.js';
export { resolveLocalDefinitions } from './navigation/local-definitions.js';
